import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import ReserveMenuEdit from '../reserveMenu/ReserveMenuEdit';
import { useContext, useEffect, useRef, useState } from 'react';
import { Button, Modal, Radio, Space, Switch, Tooltip, Typography } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import system from "../../../config/systematic";
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import antMessage from '../../../utils/extend/AntdNotification';
import { SocketContext } from '../../../App';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';
import { useReactToPrint } from 'react-to-print';
import arrayHandle from '../../../utils/baseLib/arrayHandle';
import CustomPrint from './CustomPrint';

const { Paragraph } = Typography;

export default function ReserveMenu(props: any) {

    const ref = useRef<any>(undefined);
    const notificationApi = useNotificationInstance();
    const contentRef = useRef<HTMLDivElement>(null);
    const iframeRef = useRef<any>(null);

    let { closeModal, isModel, customerReserveId, data } = props;

    if (typeof data === "undefined") data = {};
    let { handleEditAuthority } = data;
    if (typeof data.handleEditAuthority === "undefined") handleEditAuthority = { reserveMenuStateId: [1, 2, 3, 4, 5] };

    const [outputHtml, setOutputHtml] = useState<any>();

    const [customPrintVisible, setCustomPrintVisible] = useState(false);
    const [reserveMenuData, setReserveMenuData] = useState<any>();

    // /** 预订房间数据 */
    // const [reserveRoomData, setReserveRoomData] = useState<any>();

    /** 预订菜式数据 */
    const [reserveMenuDetailData, setReserveMenuDetailData] = useState<any>();

    /** 显示预订菜式 */
    const [showReserveMenuDetailVisible, setShowReserveMenuDetailVisible] = useState<any>(false);

    /** 预订菜单名称 */
    const [reserveMenuNameData, setReserveMenuNameData] = useState<any>();

    const [showType, setShowType] = useState('3');

    const showTypeOptions = [
        { label: '仅看没预订', value: '1' },
        { label: '仅看有预订', value: '2' },
        { label: '全部显示', value: '3' },
    ];

    /** api服务id */
    const apiId = 'reserveMenu';

    /** 后端数据Service */
    let wmService = system.wmService;

    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }
        //同步获取数据 async - await
        const fetchData = async () => {

        };

        if (contextData?.currentBranchStoreId) {
            if (contextData?.refresh) {
                onRefresh({ branchStoreId: contextData?.currentBranchStoreId })
            }
        }

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contextData?.currentBranchStoreId]); //初始化数据

    //打开订位信息
    // const handleShowReserve = (record: any) => {
    //     fetchApi.GET(wmService, {
    //         apiId: "customerReserve",
    //         apiExtend: 'showSingle',
    //         apiVariable: record.customerReserveId
    //     }).then(res => {
    //         if (res.success) {
    //             console.log(res.data);
    //         }
    //     })
    // };

    const showTypeChange = (e: any) => {
        setShowType(e.target.value);
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                customerReserveId,
                showType: e.target.value,
                branchStoreId: contextData?.currentBranchStoreId
            }
        }
        ref.current.initData(currentData);
    };



    //关闭查看菜式
    const onCloseReserveMenuDetail = () => {
        setShowReserveMenuDetailVisible(false);
    }

    const handleCustomPrint = async (record: any) => {
        fetchApi.GET(wmService, {
            apiId: "reserveMenu",
            apiExtend: 'wmShowReserveMenuDetail',
            apiVariable: record.id
        }).then(async res => {
            if (res.success) {
                if (res.data.reserveMenuPrivateCategorys.length < 1) {
                    antMessage('error', '提示', "目前还没有菜式。");
                }
                else {
                    setReserveMenuData({ ...record, reserveMenuDetail: res.data });
                    setCustomPrintVisible(true);
                }
            }
        })
    }

    const closeCustomPrint = (state: boolean) => {
        setCustomPrintVisible(false);
    };

    //打开打印简易菜单
    const handlePrintSimple = async (record: any) => {
        fetchApi.GET(wmService, {
            apiId: "reserveMenu",
            apiExtend: 'wmShowReserveMenuDetail',
            apiVariable: record.id
        }).then(async res => {
            if (res.success) {
                if (res.data.reserveMenuPrivateCategorys.length < 1) {
                    antMessage('error', '提示', "目前还没有菜式。");
                }
                else {
                    //把副脚注的@price替换为价格
                    let subFootnote = res.data.subFootnote ? res.data.subFootnote.replace(new RegExp("@price", "gm"), res.data.originalPrice) : '';

                    //获取样式里面服务费的addonBefore和addonAfter
                    let style = res.data.reserveMenuModel.reserveMenuStyles;
                    let findServiceCharge: any = await arrayHandle.findValue(style, 'reserveMenuModuleId', 'serviceCharge');
                    let serviceCharge: any;
                    if (findServiceCharge) {
                        let serviceChargeData = JSON.parse(findServiceCharge.data.extendParameters);
                        serviceCharge = res.data.serviceCharge ? (serviceChargeData.addonBefore + res.data.serviceCharge + serviceChargeData.addonAfter) : '';
                    }

                    const iframe = iframeRef.current;
                    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

                    // 写入要打印的内容
                    iframeDoc.open();
                    iframeDoc.write(`
                        <html>
                            <body style="background-color:#fffcdb;">
                                <div style="text-align: center; font-size: 30px;">${res.data.title ? res.data.title : ''}</div>
                                <div style="text-align: center; font-size: 20px;">${res.data.subtitle ? res.data.subtitle : ''}</div>
                                <div style="line-height: 180%">
                                    ${res.data.reserveMenuPrivateCategorys.map((item: { reserveMenuCategory: { reserveMenuCategoryName: any; }; reserveMenuDetails: any[]; }) => `
                                    <div style="text-align: center; color: red; font-size: 20px;">${item.reserveMenuCategory.reserveMenuCategoryName}</div>

                                    <!-- 内层循环：reserveMenuDetails 数组 -->
                                    ${item.reserveMenuDetails?.map(items => `
                                    <div style="text-align: center; font-size: 15px;">${items.otherFoodName ? items.otherFoodName : items.menuSpec.menu.foodName}</div>`
                    ).join('')}`).join('')}
                                </div>
                                <div style="text-align: center; font-size: 10px;">${serviceCharge}</div>
                                <div style="text-align: center; font-size: 10px;">${res.data.footnote ? res.data.footnote : ''}</div>
                                <div style="text-align: center; font-size: 10px;">${subFootnote}</div>
                            </body>
                        </html>
                    `);
                    iframeDoc.close();

                    // 触发打印
                    iframe.contentWindow.print();
                }
            }
        })
    }

    //打开打印菜单
    const handlePrint = async (record: any) => {        
        await setOutputHtml(record.outputHtml);
        print();
    }

    //打印模块
    const print = useReactToPrint({
        contentRef,
        // pageStyle: `
        // @media print {
        //     @page {
        //         size: A4;
        //         zoom: 2
        //     }
        // }`
    })

    //打开查看菜单
    const handleShowMenu = (record: any) => {
        fetchApi.GET(wmService, {
            apiId: "reserveMenu",
            apiExtend: 'wmShowReserveMenuDetail',
            apiVariable: record.id
        }).then(res => {
            if (res.success) {
                if (res.data.reserveMenuPrivateCategorys.length < 1) {
                    antMessage('error', '提示', "目前还没有菜式。");
                }
                else {
                    setReserveMenuDetailData(res.data);
                    setShowReserveMenuDetailVisible(true);
                }
            }
        })
        setReserveMenuNameData(record.reserveMenuName);
    };

    const showRoom = (rows: any) => {
        let roomNames = '';
        for (var i = 0, len = rows.length; i < len; i++) {
            if (roomNames !== '') {
                roomNames = roomNames + " | " + rows[i].room.roomName;
            }
            else {
                roomNames = rows[i].room.roomName;
            }
        }
        return roomNames;
    };

    const showData = (rows: any) => {
        if (typeof rows !== "undefined") {
            rows = rows;
            return (
                <Typography>
                    <Paragraph>
                        <div style={{ textAlign: 'center', color: 'red', fontSize: '30px' }}>{rows.title}</div>
                        <div style={{ textAlign: 'center', fontSize: '20px' }}>{rows.subtitle}</div>
                    </Paragraph>
                    {
                        rows.reserveMenuPrivateCategorys.map((item: any) => {
                            return (
                                <>
                                    <Paragraph>
                                        <div style={{ textAlign: 'center', color: 'yellow', fontSize: '20px' }}>{rows.showLanguageTypeId === 'CN' || rows.showLanguageTypeId === 'CE' ? item.reserveMenuCategory.reserveMenuCategoryName : ""}</div>
                                        <div style={{ textAlign: 'center', color: 'yellow', fontSize: '20px' }}>{rows.showLanguageTypeId === 'EN' ? item.reserveMenuCategory.reserveMenuCategoryNameEn : ""}</div>
                                        <div style={{ textAlign: 'center', color: 'yellow', fontSize: '12px' }}>{rows.showLanguageTypeId === 'CE' ? item.reserveMenuCategory.reserveMenuCategoryNameEn : ""}</div>
                                    </Paragraph>
                                    {
                                        item.reserveMenuDetails.map((items: any) => {
                                            return (
                                                <>
                                                    <Paragraph>
                                                        <Tooltip placement="right" styles={{ root: { maxWidth: 'none' } }} title={
                                                            <Paragraph style={{ whiteSpace: 'pre-wrap', fontSize: 20 }}>
                                                                {
                                                                    "ID：" + items.id + "\n" +
                                                                    items.menuSpec.menu.foodName + "      " + items.amount + " " + items.productUnitName + "\n\n" +
                                                                    ("规格：" + items.menuSpec.menuSpecName + "\n") +
                                                                    (items.menuSpecSpecialIds.length > 0 ? "特殊规格：" + items.menuSpecSpecialNames + "\n" : "") +
                                                                    (items.condimentIds.length > 0 ? "加料：" + items.condimentNames + "\n" : "") +
                                                                    (items.memoIds.length > 0 ? "备注：" + items.memoNames + "\n" : "") +
                                                                    (items.memo ? "特殊备注：" + items.memo + "\n" : "") +
                                                                    (sessionStorage.getItem('isAdmin') === 'true' ? (items.extendParameters ? "扩展参数：" + items.extendParameters + "\n" : "") : "") +
                                                                    ("\n操作人：" + items.userName)
                                                                }
                                                            </Paragraph >
                                                        } color='green'>
                                                            <div style={{ textAlign: 'center', fontSize: '15px' }}>{rows.showLanguageTypeId === 'CN' || rows.showLanguageTypeId === 'CE' ? (items.otherFoodName ? items.otherFoodName : items.menuSpec.menu.foodName) : ""}</div>
                                                            <div style={{ textAlign: 'center', fontSize: '15px' }}>{rows.showLanguageTypeId === 'EN' ? (items.otherFoodNameEn ? items.otherFoodNameEn : items.menuSpec.menu.foodNameEn) : ""}</div>
                                                            <div style={{ textAlign: 'center', fontSize: '12px' }}>{rows.showLanguageTypeId === 'CE' ? (items.otherFoodNameEn ? items.otherFoodNameEn : items.menuSpec.menu.foodNameEn) : ""}</div>
                                                        </Tooltip>
                                                    </Paragraph >
                                                </>
                                            )
                                        })
                                    }
                                </>
                            )
                        })
                    }
                    <Paragraph>
                        <div style={{ textAlign: 'center', fontSize: '10px' }}>{rows.footnote}</div>
                        <div style={{ textAlign: 'center', fontSize: '10px' }}>{rows.subFootnote}</div>
                    </Paragraph>
                </Typography >
            )
        }
    };

    //表头
    const columnsHead = [
        // {
        //     title: '所属分店',
        //     dataIndex: 'branchStoreName',
        // },
        {
            title: '预订菜单名称',
            dataIndex: 'reserveMenuName',
            render: (text: any, record: any) => {
                return (
                    <Tooltip placement="topLeft" title={"转单备注：" + record.convertMemo} color='green'>
                        <div>{text + (record.memo ? " ( " + record.memo + " )" : "")}</div>
                    </Tooltip>
                )
            }
        },
        {
            title: '订位信息',
            dataIndex: 'customerReserve',
            key: 'customerReserve',
            render: (text: any, record: any) => {
                if (record.customerReserveId) {
                    if (JSON.stringify(record.customerReserve) !== '{}') {
                        return (
                            <div>
                                <Typography>
                                    <Paragraph>
                                        <div style={{ textAlign: 'center' }}>{record.customerReserve.contact + " " + record.customerReserve.appellationName}</div>
                                        <div style={{ textAlign: 'center' }}>{record.customerReserve.contactCall}</div>
                                        <div style={{ textAlign: 'center' }}>{record.customerReserve.timeType.bookingDate}</div>
                                        <div style={{ textAlign: 'center' }}>{record.customerReserve.timeType.typeName}</div>
                                        <div style={{ textAlign: 'center' }}>{showRoom(record.customerReserve.tempRooms)}</div>
                                    </Paragraph>
                                </Typography >
                            </div>
                        )
                    }
                    else {
                        return (
                            <div>
                                <Typography>
                                    <Paragraph>
                                        <div style={{ color: 'orange', textAlign: 'center' }}>找不到订位信息</div>
                                        <div style={{ color: 'orange', textAlign: 'center' }}>(预订ID有误)</div>
                                    </Paragraph>
                                </Typography >
                            </div>
                        )
                    }
                }
                else {
                    return (
                        <div style={{ color: 'red' }}>还没绑定订位信息</div>
                    )
                }
            }
        },
        {
            title: '预订菜式',
            dataIndex: 'showMenu',
            key: 'showMenu',
            render: (text: any, record: any) => {
                return (
                    <Space size="small">
                        <Button size={"small"} type="primary" onClick={() => handleShowMenu(record)}>预订菜式</Button>
                    </Space>
                )
            }
        },
        {
            title: '打印菜单',
            dataIndex: 'print',
            key: 'print',
            render: (text: any, record: any) => {
                // if (record.reserveMenuStateId === 6) {
                return (
                    <Space size="small">
                        <Button size={"small"} type="primary" onClick={() => handlePrint(record)}>正式菜单</Button>
                        {/* <Button size={"small"} type="primary" onClick={() => handlePrintSimple(record)}>简易菜单</Button> */}
                        <Button size={"small"} type="primary" onClick={() => handleCustomPrint(record)}>自定义菜单</Button>
                    </Space>
                )
                // }
            }
        },
        {
            title: '价格',
            dataIndex: 'originalPrice',
            render: (text: any, record: any) => {
                return (
                    <div style={{ fontSize: 20, color: 'yellow' }}>
                        {"¥ " + text}
                    </div>
                )
            }
        },
        {
            title: '菜单状态',
            dataIndex: 'reserveMenuState',
            render: (text: any, record: any) => {
                return (
                    <div style={{ color: record.reserveMenuStateId === 6 ? '#00ff00' : '#ff0000' }}>{record.reserveMenuStateName}</div>
                )
            }
        },
        // {
        //     title: '排序',
        //     dataIndex: 'sortBy',
        // },
        // {
        //     title: '允许他人修改',
        //     dataIndex: 'isModifyByOther',
        //     render: (text: any, record: any) => (
        //         <Switch checkedChildren="允许" unCheckedChildren="不允许"
        //             checked={text} key={record.id}
        //             onChange={(e) => handleChange(record.id, 'isModifyByOther', e)}
        //         />
        //     )
        // },
        {
            title: '转订单',
            dataIndex: 'isConverted',
            render: (text: any, record: any) => {
                if (text) {
                    return (
                        <Switch checkedChildren="已转" unCheckedChildren="未转"
                            checked={text} key={record.id}
                            onChange={(e) => handleChange(record.id, 'isConverted', e)}
                        />
                    )
                }
                else {
                    return (
                        <Switch checkedChildren="已转" unCheckedChildren="未转"
                            checked={text} key={record.id}
                        />
                    )
                }
            }


        },
        // {
        //     title: '操作人',
        //     dataIndex: 'userName',
        //     // render: (text: any, record: any) => {
        //     //     return (
        //     //         <Tooltip placement="topLeft" title={"更新于：" + dayjs(record.sysDate.updatedAt).format('YYYY-MM-DD HH:mm:ss')} color='red'>
        //     //             <div>{text}</div>
        //     //         </Tooltip>
        //     //     )
        //     // }
        // },
    ];

    const initData = async () => {
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                customerReserveId: customerReserveId,
                showType,
                branchStoreId: contextData?.currentBranchStoreId
            },
        }
        ref.current.initData(currentData);
    }

    //改变数据
    const handleChange = async (id: any, columnName: string, isValue: boolean) => {
        const bodys = {
            apiId: "reserveMenu",
            apiVariable: id,
            apiExtend: 'updateOne',
            apiData: {
                columnName,
                value: isValue,
            }
        }
        fetchApi.PUT(wmService, bodys).then(res => {
            showCustomNotification(notificationApi!, {
                type: 'success',
                message: '编辑成功',
                description: 'success',
            });;
            initData();
        }).catch(err => {
            antMessage('error', '删编辑失败', err.message);
        })
    };

    const handleOk = (e: any) => {
        closeModal(true);
    };

    const onRefresh = (item: any) => {
        const { branchStoreId } = item;
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                customerReserveId: customerReserveId,
                showType,
                branchStoreId
            }
        }
        ref.current.initData(currentData);

        ref.current.changeLogger({
            isChangeLoggerQueryTypeExtendId: true,
            loggerQueryTypeExtendId: branchStoreId
        })

        setContextData({ ...contextData, refresh: false })
    }

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '预订菜单',
        apiId: 'reserveMenu',
        showStates: true,
        showAdd: false,
        showLogger: {
            logger: {
                id: 'reserveMenuOpLogger'
            },
            loggerDisplay: true,
            loggerSingleDisplay: true,
            loggerQueryType: 'reserveMenu',
            // loggerQueryTypeExtendId: localStorage.getItem("currentBranchStoreId")
            loggerQueryTypeExtendId: contextData?.currentBranchStoreId,
        },
        columns,
        pagination: true,
        EditComponent: ReserveMenuEdit,
        handleEditAuthority,
        sendPageData: {
            customerReserveId: customerReserveId,
            branchStoreId: contextData?.currentBranchStoreId
        },
        mountDataOptions: {
            userMount: {
                isDept: true
            }
        }
    };

    return (
        <>
            {/* {!isModel ? <BranchStoreList onRefresh={onRefresh}></BranchStoreList> : ""} */}
            <br></br>
            <Modal
                title={"【 " + reserveMenuNameData + " 】的预订菜式"}
                open={showReserveMenuDetailVisible}
                okText='关闭'
                onOk={onCloseReserveMenuDetail}
                onCancel={onCloseReserveMenuDetail}
                cancelButtonProps={{ style: { display: "none" } }}
                closable={false}
                style={{ fontSize: '20px' }}
                width={500}
            >
                {showData(reserveMenuDetailData)}
            </Modal>
            <div style={{ display: "none" }}>
                <div ref={contentRef} dangerouslySetInnerHTML={{ __html: outputHtml }}></div>
            </div>
            <br></br>
            <div style={{ display: "none" }}>
                <iframe
                    ref={iframeRef}
                    title="print-iframe"
                    style={{ position: 'absolute', width: 0, height: 0, border: 0 }}
                />
            </div>
            <br></br>
            {isModel ?
                <AntDraggableModal
                    title={'预订菜单'}
                    open={true}
                    okText='确定'
                    cancelButtonProps={{ style: { display: "none" } }}
                    onOk={handleOk}
                    closable={false}
                    maskClosable={false}
                    width={1200}>
                    <WebUniversalNewEx props={extendProps} ref={ref}></WebUniversalNewEx>
                    {customPrintVisible
                        ? (<CustomPrint closeModal={closeCustomPrint} reserveMenuData={reserveMenuData} />)
                        : null}
                </AntDraggableModal>
                :
                <div>
                    <Space>
                        <Radio.Group
                            options={showTypeOptions}
                            onChange={showTypeChange}
                            value={showType}
                            optionType="button"
                            buttonStyle="solid"
                        />
                    </Space>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <WebUniversalNewEx ref={ref} props={extendProps}></WebUniversalNewEx>
                    {customPrintVisible
                        ? (<CustomPrint closeModal={closeCustomPrint} reserveMenuData={reserveMenuData} />)
                        : null}
                </div>
            }
        </>
    )
}